<template>
  <el-row :gutter="20">
    <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="16">
      <div class="module-header">
        <span>{{ title }}</span>
        <div>
          选择模板：
          <el-select v-model="templateId" @change="onChangeTemplate" filterable placeholder="请选择" style="width: 200px;">
            <el-option v-for="(item, index) in templateList" :key="item.sizeCleanRuleTemplateId" :label="item.name" :value="index"></el-option>
          </el-select>
        </div>
      </div>
      <table class="table">
        <tr>
          <th width="60">步骤</th>
          <th width="40"></th>
          <th>明细</th>
          <th width="200">操作</th>
        </tr>
        <draggable tag="tbody" v-model="data.sizeCleanRuleDetails" @end="sortList" handle=".el-icon-sort" draggable=".sort-item">
          <tr slot="header">
            <td>1</td>
            <td></td>
            <td>
              <span style="margin: 0 5px;">使用</span>
              <el-select v-model="data.source" size="small" style="width: 160px">
                <el-option label="size" :value="1"></el-option>
                <el-option label="country size" :value="2"></el-option>
                <el-option label="size+country size" :value="3"></el-option>
              </el-select>
              <span style="margin: 0 5px;">作为清洗对象</span>
            </td>
            <td></td>
          </tr>
          <tr class="sort-item" v-for="(rule, rindex) in data.sizeCleanRuleDetails" :key="'country-size-'+rindex">
            <td>{{ rindex + 2 }}</td>
            <td><i class="el-icon-sort"></i></td>
            <td>
              <template v-for="(item, index) in rule.ruleParamVoList">
                <el-input v-if='item.type==1' :key="'input-'+index" size="small" v-model="rule.ruleParamVoList[index].value" style="width: 100px"></el-input>
                <el-select v-else-if='item.type==2' :key="'select-'+index" v-model="rule.ruleParamVoList[index].value" size="small" style="width: 130px">
                  <el-option v-for="(item,index) in rule.ruleParamVoList[index].options" :key="index" :label="item.value" :value="item.key"></el-option>
                </el-select>
                <span :key="index" v-else style="margin: 0 5px;">{{item.value}}</span>
              </template>
            </td>
            <td>
              <el-link class="mr10" type="primary" @click="removeItem(rindex)">删除</el-link>
              <el-link v-if="rindex > 0" class="mr10" type="primary" @click="moveItem(rindex, -1)">上移</el-link>
              <el-link v-if="rindex < data.sizeCleanRuleDetails.length - 1" type="primary" @click="moveItem(rindex, 1)">下移</el-link>
            </td>
          </tr>
        </draggable>
      </table>
    </el-col>
  </el-row>
</template>

<script>
import draggable from "vuedraggable";

export default {
  props: {
    title: String,
    templateList: Array,
    data: Object,
  },
  components: {
    draggable
  },
  data() {
    return {
      templateId: null,
    };
  },
  methods: {
    onChangeTemplate(index) {
      const template = this.templateList[index];
      this.data.sizeCleanRuleDetails.push({
        sizeCleanRuleDetailId: null,
        ruleSort: null,
        sizeCleanRuleTemplateId: template.sizeCleanRuleTemplateId,
        description: template.description,
        ruleParamVoList: template.paramDefinitions.map(item => {
          return {
            number: item.number,
            type: item.type, // 1-输入框 2-下拉框
            value: item.value || null,
            options: item.options,
          }
        }),
      });
      this.templateId = null;
    },
    removeItem(index) {
      this.data.sizeCleanRuleDetails.splice(index, 1);
    },
    moveItem(index, num) {
      const item = this.data.sizeCleanRuleDetails.splice(index, 1)[0];
      this.data.sizeCleanRuleDetails.splice(index + num, 0, item);
    },
    sortList() {

    },
  },
};
</script>
<style lang="less" scoped>
.ml10 {
  margin-left: 10px;
}
.mr10 {
  margin-right: 10px;
}
.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  th {
    padding: 10px 10px;
    text-align: left;
    font-weight: normal;
    background-color: #f5f7fa;
  }
  td {
    padding: 5px 10px;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
}
.el-icon-sort {
  cursor: pointer;
}
</style>
